<template>
  <span style="text-align:left;">
    <template v-if="modo == 'new' || modo == 'edit' || modo == 'flow'">
      <v-radio-group
        row
        :mandatory="false"
        v-model="intravalue"
        required
        :rules="crud.evalrules(campo)"
        :hint="T(campo.cmp_dica)"
        persistent-hint
      >
        <v-radio
          v-for="n in items"
          :key="n.k"
          :label="T(n.v)"
          :value="n.k"
        ></v-radio>
      </v-radio-group>
    </template>

    <template v-if="modo == 'list' || modo == 'view' || modo == 'viewmode'">
      <span :class="{ 'text-xs-center': modo == 'list' }">{{
        valoramostrar
      }}</span>
    </template>

    <template v-if="modo == 'filtro'">
      <v-select
        height="20"
        class="ma-0 pa-1"
        hide-details
        :items="items"
        item-text="v"
        item-value="k"
        clearable
        v-on:keyup.enter="onEnter"
        v-bind:value="preLoad(value)"
        v-on:input="event => $emit('input', preUpdate(event))"
      ></v-select>
    </template>
  </span>
</template>

<script>
try {
  var _baseComponent = require("@/lib/componente/_base.vue").default;
} catch (err) {
  var _baseComponent = require("@/framework/lib/componente/_base.vue").default;
}
export default {
  extends: _baseComponent,
  data() {
    return {
      intravalue: this.preLoad(this.value),
      items: (() => {
        let array = this.campo.cmp_valores
          .split(",")
          .map(t => global.fn.T(t, null, null, this))
          .map((v, i) => ({ k: i, v: this.computeContaVal(v.trim()) }));

        return array;
      })()
    };
  },
  computed: {
    valoramostrar() {
      if (this.value === null) return "";
      let sel = _.filter(this.items, { k: this.value });
      if (sel && sel[0]) return sel[0].v;
    }
  },
  methods: {
    preLoad(myval) {
      if (myval == undefined) return null;
      return myval;
    },
    preUpdate(myval) {
      return myval;
    }
  },
  watch: {
    intravalue(val) {
      this.$emit("input", this.preUpdate(val));
    },

    value: {
      handler(val) {
        this.intravalue = this.preLoad(this.value);
      },
      deep: true
    }
  }
};
</script>

<style scoped></style>
